import API from "@/utils/API";

function getVersion() {
  let version =  {
    PgmVersion: "</>",
    VueJs: "</>",
  }

  API.get("getVersion", {}).then((version_Pgm) => {
    version.PgmVersion = version_Pgm.PgmVersion;

    // BUGS et ENV sont normalement des variables globales, on vérifie qu'il existe
    if (typeof BUGS !== "undefined" && typeof ENV !== "undefined") {
      version.VueJs = ENV.VERSION;

      BUGS.version = {
        version_Pgm: version.PgmVersion,
        version_App: version.VueJs,
      };
    }
    console.info(
      `%cVersion PgmVersion : "${version.PgmVersion}"` +
      `\nVersion App : ${version.VueJs}` +
      `\nApplication : ${$root.application}`,
      "color:green; font-size:18px; font-weight: bold;"
    );

  });
}

export default getVersion
